import styled from 'styled-components'
import { Check } from '@geist-ui/icons'
import { Mail } from '@geist-ui/react-icons'
import { Button, GeistProvider, Input } from '@geist-ui/react'
import { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { wSaveNotificationsEmailAtom } from '../../atoms/profile'
import useAuth from '../../hooks/auth'
import React from 'react'
import { db } from '../../data/FirebaseUtils'

/*======================== React component ===================================*/

const EmailNotificationInputItem = (): JSX.Element => {
  const [hasContactEmail, setHasContactEmail] = useState(true)
  const [email, setEmail] = useState<string>('')
  const [, saveUserEmail] = useAtom(wSaveNotificationsEmailAtom)
  const [enabled, setEnabled] = useState(false)
  const { profile } = useAuth()

  // Check validity of user email using a regex in useeffect
  useEffect(() => {
    setEnabled(email.length > 0 && email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g) !== null)
  }, [email])

  useEffect(() => {
    const address = profile?.address

    if (address) {
      db.secrets(address)
        .doc('confidential')
        .onSnapshot((doc) => {
          if (doc.exists) {
            const data = doc.data()
            if (data) {
              setHasContactEmail(data['email'] !== undefined)
            } else {
              setHasContactEmail(false)
            }
          } else {
            setHasContactEmail(false)
          }
        })
    }
  }, [profile?.address])

  //TODO: Check if email has a valid format

  return (
    <Wrapper isVisible={!hasContactEmail}>
      <Divider />
      <ColumnSpacer height="15px" />
      <Text>{`Stay up to date.`}</Text>
      <ColumnSpacer height={'5px'} />
      <SubText>We&apos;ll notify you when you&apos;ve bought or sold an NFT.</SubText>
      <ColumnSpacer height={'15px'} />
      <Row>
        <Input
          icon={<Mail color="white" />}
          placeholder="Type your email address"
          width="100%"
          name="email"
          id="email"
          required
          enterKeyHint={undefined}
          onChange={(e) => setEmail(e.target.value.trim())}
        />
        <RowSpacer width={'5%'} />
        <GeistProvider themeType={enabled ? 'light' : 'dark'}>
          <Button
            disabled={!enabled}
            auto
            width="20%"
            scale={0.75}
            icon={<Check />}
            onClick={() => {
              saveUserEmail(email)
            }}
          />
        </GeistProvider>
      </Row>
      <ColumnSpacer height={'20px'} />
      <Divider />
    </Wrapper>
  )
}

export default EmailNotificationInputItem

/*======================== Styled components =================================*/

const Text = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
  padding: 0;
  text-align: left;
`

const SubText = styled.p`
  font-size: 0.8rem;
  font-weight: 400;
  color: #fff;
  margin: 0;
  padding: 0;
  text-align: left;
`

const Wrapper = styled.div<{ isVisible: boolean }>`
  display: ${(props) => (props.isVisible ? 'flex' : 'none')};
  flex-direction: column;
  width: calc(100% - 20px);
  cursor: pointer;
  border-radius: 10px;
  padding-left: 30px;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const RowSpacer = styled.div<{ width: string }>`
  width: ${(props) => props.width};
`

const ColumnSpacer = styled.div<{ height: string }>`
  height: ${(props) => props.height};
`

const Divider = styled.div`
  width: 100%;
  background: #8b8b8b;
  height: 1px;
`
